import { useState, useCallback } from 'react'
import useServiceLogsResources from '../../shared/resources/api/v1/admin/docker/useServiceLogsResources'

export default function useServiceLogsState(teamSlug, projectSlug, serviceSlug) {
  const [logs, setLogs] = useState([])
  const [loading, setLoading] = useState(true)
  const [meta, setMeta] = useState({ total: 0, limit: 50, offset: 0 })

  const { all } = useServiceLogsResources(teamSlug, projectSlug, serviceSlug)

  const load = useCallback((params = {}) => {
    setLoading(true)
    return all(params)
      .then((response) => {
        setLogs(response.serviceLogMessages || [])
        setMeta(response.meta || { total: 0, limit: 50, offset: 0 })
      })
      .catch(() => {
        setLogs([])
        setMeta({ total: 0, limit: 50, offset: 0 })
      })
      .finally(() => setLoading(false))
  }, [all])

  const refresh = useCallback((params = {}) => {
    return all(params)
      .then((response) => {
        setLogs(response.serviceLogMessages || [])
        setMeta(response.meta || { total: 0, limit: 50, offset: 0 })
      })
      .catch(() => {
        setLogs([])
        setMeta({ total: 0, limit: 50, offset: 0 })
      })
  }, [all])

  return {
    logs,
    loading,
    meta,
    load,
    refresh,
  }
}
